import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import PurchaseSuccess from '../purchase/PurchaseSuccess';
import Spinner from '../global/Spinner';

class DiscoverAlbumFolderSuccess extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        albumFolderId: PropTypes.string.isRequired,
      }),
    }),
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
      root: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    purchasedSubscription: PropTypes.bool,
    loading: PropTypes.bool,
  };

  render() {
    const { albumFolder, loading, location, purchasedSubscription } =
      this.props;
    const { purchasedPrepaidItems } = qs.parse(location.search);

    if (loading) {
      return <Spinner />;
    }

    return (
      <PurchaseSuccess
        stringContext={albumFolder}
        purchasedSubscription={purchasedSubscription}
        purchasedPrepaidItems={['1', 'true', 1, true].includes(
          purchasedPrepaidItems,
        )}
      />
    );
  }
}

export default DiscoverAlbumFolderSuccess;
